import { Link } from 'react-router-dom';
import { sites, categories } from '@/mocks/sites';
import { useTranslation } from 'react-i18next';

export default function HotSites() {
  const { t } = useTranslation();
  const featuredSites = sites.filter((s) => s.featured).slice(0, 12);

  const getCategoryColor = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    if (!cat) return 'bg-secondary-100/80 text-secondary-700';
    const map: Record<string, string> = {
      primary: 'bg-primary-100/70 text-primary-700',
      accent: 'bg-accent-100/80 text-accent-700',
      secondary: 'bg-secondary-100/80 text-secondary-700',
    };
    return map[cat.color] || map.primary;
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              {t('hotRecommend')}
            </h2>
            <p className="text-sm text-foreground-600">精选优质网站，品质有保障</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
          {featuredSites.map((site) => (
            <a
              key={site.id}
              href={site.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-gradient-to-br from-primary-100 to-primary-200 text-primary-700 font-bold text-sm">
                  {site.name.charAt(0)}
                </div>
                <div className="w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-external-link-line text-xs text-foreground-400"></i>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                {site.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {site.description}
              </p>
              <div className="flex items-center gap-1.5 flex-wrap">
                <span className={`px-2 py-0.5 rounded text-xs font-medium ${getCategoryColor(site.category)}`}>
                  {categories.find((c) => c.slug === site.category)?.name}
                </span>
                {site.tags.slice(0, 2).map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 rounded text-xs bg-background-100 text-foreground-500"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}